import './SignUp.css'
import bankimg from '../imgs/finance-vector.png'
import { Link, Redirect } from 'react-router-dom'
import { useState } from 'react'

export default function SignUp(props) {
    const [error, setErrors] = useState(false)
    const [redirect, setRedirect] = useState(false)
    
    const addUserToAPI = async () => {
        const queryResults = await fetch(`${process.env.REACT_APP_API_URL}/createuser`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'first_name': document.getElementById('fname-input').value,
                'last_name': document.getElementById('lname-input').value,
                'email': document.getElementById('email-input').value,
                'password': document.getElementById('pass-input').value
            })
        })

        const queryResultsJSON = await queryResults.json()
        
        if (queryResultsJSON.error !== undefined){
            if(queryResultsJSON.error === 'non_unique_email'){
                document.getElementById('errors').innerHTML = 'Errors: <li>E-Mail already in use</li>'
                setErrors(true)
            }else if (queryResultsJSON.error === 'unknown_error'){
                alert("unknown database error")
            }
        }else{
            setRedirect(true)
        }
    }

    const verifyInputs = () => {
        let errorString = ''
        const validFirstName = /^(\s)*[a-zA-ZÀ-ÖØ-öø-ÿ]+((\s)?(('|-|\.)?([a-zA-ZÀ-ÖØ-öø-ÿ])+))*(\s)*$/.test(document.getElementById('fname-input').value)
        if (!validFirstName) {
            setErrors(true)
            errorString += '<li>Invalid First Name</li>'
        }

        const validLastName = /^(\s)*[a-zA-ZÀ-ÖØ-öø-ÿ]+((\s)?(('|'|\.)?([a-zA-ZÀ-ÖØ-öø-ÿ])+))*(\s)*$/.test(document.getElementById('lname-input').value)
        if (!validLastName) {
            setErrors(true)
            errorString += '<li>Invalid Last Name</li>'
        }

        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        const validEmail = emailRegex.test(document.getElementById('email-input').value)
        if (!validEmail) {
            setErrors(true)
            errorString += '<li>Invalid E-Mail</li>'
        }


        const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/
        const validPass = passwordRegex.test(document.getElementById('pass-input').value)
        if (!validPass) {
            setErrors(true)
            errorString += '<li>Invalid Password</li>'
        }

        const passMatch = (document.getElementById('pass-input').value === document.getElementById('confirm-pass-input').value)
        if (!passMatch) {
            setErrors(true)
            errorString += '<li>Passwords do not match</li>'
        }

        document.getElementById('errors').innerHTML = 'Errors: ' + errorString

        if (validFirstName && validLastName && validEmail && validPass && passMatch) {
            setErrors(false)
            addUserToAPI()
        }
    }

    if(!redirect){
        return (
            <div className='signup'>
                <div className='left-side'>
                    <img src={bankimg} className='bank-vector-image' alt='Presonal Finance' />
                    <div className='bank-image-caption'>You are now clicks away from having the power of a bird's eye view of your personal finance</div>
                </div>
    
                <div className='right-side'>
                    <div className='signup-form-container'>
                        <div className='signup-title'>Sign Up</div>
                        <div className='signup-subtitle'>
                            Let's get you all set up so you can verify your personal account and begin setting up your profile!
                        </div>
                        <div id='errors' style={{ display: error ? '' : 'none' }}></div>
                        <label htmlFor='fname-input' className='double-label left-label'>First Name</label>
                        <label htmlFor='lname-input' className='double-label'>Last Name</label>
                        <input type='text' className='double-input left-input' id='fname-input'></input>
                        <input type='text' className='double-input' id='lname-input'></input>
                        <label htmlFor='email-input' className='email-label'>E-Mail</label>
                        <input type='text' id='email-input'></input>
                        <label htmlFor='pass-input' className='double-label left-label'>Password</label>
                        <label htmlFor='confirm-pass-input' className='double-label'>Confirm Password</label>
                        <input type='password' className='double-input left-input' id='pass-input'></input>
                        <input type='password' className='double-input' id='confirm-pass-input'></input>
                        <button id='submit-button'
                            onClick={() => {
                                verifyInputs()
                            }}
                        >
                            Create Account
                        </button>
                        <div className='login-switch'>Have an account? <Link to='/login'>Login</Link></div>
                    </div>
                </div>
            </div>
        )
    }else{
        return(
            <Redirect to='/home' />
        )
    }
    
}